module.exports = __webpack_public_path__ + "static/media/fire9.8b093099.svg";